import { DateTime } from 'luxon';
import { Settings } from 'luxon';

Settings.defaultZone = 'Europe/Warsaw';

export const parseDateWithZone = (date: string) => {
  const d = DateTime.fromISO(date).toMillis();
  return d;
};
